import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';
import { makeQueryString } from '../../util';

export type V_OrganisationTeamSub = {
  '@id': string;
  '@type': 'TeamLicence';
  id: string;
  code: string;
  claim: {
    '@id': string;
    '@type': 'UserProgramParticipation';
    user: {
      '@id': string;
      '@type': 'User';
      email: string;
      diagnoses: Array<{
        '@id': string;
        '@type': 'UserDiagnosis';
        type: string;
      }>;
    };
  } | null;
  createdAt: string;
  expiresAt: string | null;
  revokedAt: string | null;
};

export type W_BulkUpdate = {
  licenceIds: Array<string>;
  expiresAt: string | null;
  revoke: boolean;
  team: string | null;
};

export function useReadCollectionLicences(
  id: string,
  queryParams?: { 'order[createdAt]'?: string },
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V_OrganisationTeamSub>>(
    `/teams/${id}/licences${makeQueryString(queryParams)}`,
    options,
  );
}
